export const toLowerCase = <Value extends string>(value: Value) =>
    value.toLowerCase() as Lowercase<Value>
